
export interface ReferralTest { name: string; code: string; }
export interface ReferralCategory { name: string; tests: ReferralTest[]; }

export const CATEGORIES: ReferralCategory[] = [
  {
    name: "המטולוגיה",
    tests: [
      { name: "ספירת דם - CBC", code: "85025" },
      { name: "זמן פרוטרומבין - PT", code: "" },
      { name: "זמן פרוטרומבין חלקי - PTT", code: "" },
    ],
  },
  {
    name: "כימיה",
    tests: [
      { name: "סוכר - Glucose", code: "82947" },
      { name: "המוגלובין מסוכרר - Hb A1c", code: "83036" },
      { name: "אוראה - [BUN] Urea", code: "84520" },
      { name: "קריאטינין - Creatinine", code: "82565" },
      { name: "נתרן - Sodium", code: "84295" },
      { name: "אשלגן - Potassium", code: "84132" },
      { name: "כלור - Chloride", code: "84235" },
      { name: "אלבומין - Albumin", code: "82040" },
      { name: "גלובולין - Globulin", code: "" },
      { name: "סידן - Calcium", code: "82340" },
      { name: "זרחן - Phosphorous", code: "84100" },
      { name: "חומצת שתן - Uric acid", code: "84550" },
      { name: "מגנזיום - Magnesium", code: "83735" },
      { name: "קריאטינין  קינאז - CPK", code: "82550" },
      { name: "נחושת  בדם -  Copper blood", code: "L6707" },
      { name: "בילירובין כללי -  Total bilirubin", code: "82247" },
      { name: "בילורבין ישיר - Direct bilirubin", code: "82248" },
      { name: "אלקליין פוספטאז  - Alkaline phosphatase", code: "84075" },
      { name: "לקטט דהידרוגנאז - LDH", code: "83615" },
      { name: "אספרטט אמינוטרנספראז - AST [GOT]", code: "84450" },
      { name: "אלאנין טרנסטאמינאז - [ALT [GPT", code: "84460" },
      { name: "גמא גלוטמיל טרנספפטידאז - GGT", code: "82977" },
      { name: "ברזל - Iron", code: "83540" },
      { name: "טרנספרין - Transferrin", code: "84466" },
      { name: "פריטין - Ferritin", code: "82728" },
      { name: "עמילאז - Amylase", code: "82150" },
      { name: "ליפאז - Lipase", code: "83690" },
      { name: "סך כולסטרול - Total cholesterol", code: "82465" },
      { name: "כולסטרול  \"טוב\" - HDL Cholesterol", code: "83718" },
      { name: "כולסטרול רע - HDL Cholesterol", code: "83721" },
      { name: "טריגליצרלידים - Triglycerides", code: "84478" },
      { name: "מדד דלקת ס.ר.פ - CRP", code: "86141" },
      { name: "ויטמין D די הידרוקסי  1,25  - Vitamin D", code: "82652" },
      { name: "ויטמין  D, די הידרוקסי Vitamin D - 25", code: "82306" },
      { name: "ויטמין בי -  Vitamin B12", code: "82607" },
      { name: "ויטמין בי - Vitamin B6", code: "84207" },
      { name: "ויטמין בי -  Vitanin B1", code: "82407" },
      { name: "חומצה פולית -  Folic acid [B6]", code: "82746" },
      { name: "פורינטול [שיבא]- טלפוןן03-5302358,03-53-2093", code: "65199" },
      { name: "TPMT metabolite", code: "80299" },
      { name: "אלפה פטו פרוטאין - AFP", code: "82105" },
      { name: "סמן סרטן  - CA125", code: "86300" },
      { name: "סמן סרטן  - CA19.9", code: "86301" },
      { name: "סמן סרטן קרצינואמביוניק אנטיגן - CEA", code: "82378" },
      { name: "כרומוגנין - CgA", code: "L2215" },
      { name: "CA 72.4", code: "L6312" },
      { name: "CA15.3", code: "86300" },
      { name: "סך אנטיגן כנגד פרוסטטה -  Total PSA", code: "84153" },
      { name: "אנטיגן חופשי כנגד פרוסטטה - Free PSA", code: "84154" },
      { name: "אנטיגן ספיציפי כנגד פרוסטטה - Speciific PSA", code: "84153" },
    ],
  },
  {
    name: "אנדוקרינולוגיה",
    tests: [
      { name: "טירוקסין חופשי 4 - FT4", code: "84439" },
      { name: "טירוקסין חופשי  3 - FT3", code: "84480" },
      { name: "הורמון מפריש טירוקסין - TSH", code: "84443" },
      { name: "גסטרין - Gastrin", code: "82491" },
      { name: "טריפטאז", code: "" },
    ],
  },
  {
    name: "אימונולוגיה",
    tests: [
      { name: "אלקטרופורוזיס של חלבונים - electrophoresis", code: "84615" },
      { name: "IgA", code: "l6015" },
      { name: "IgD", code: "86320" },
      { name: "IgG", code: "86320" },
      { name: "IgM", code: "86320" },
      { name: "IgG4", code: "86320" },
      { name: "Anti Transglutaminase IgA -TGG A", code: "L6015" },
      { name: "Deaminated gliadin peptidase", code: "L0762" },
      { name: "Anti Endomisial Ab", code: "86255" },
      { name: "ANA", code: "86038" },
      { name: "נוגדנים כנגד דנא - DNA - Anti double stran", code: "86225" },
      { name: "AMA", code: "86255" },
      { name: "AMA2", code: "86255" },
      { name: "ASMA", code: "86021" },
      { name: "Atypical P  ANCA", code: "87449" },
      { name: "ASCA", code: "L6039" },
      { name: "Liver 9", code: "86255" },
      { name: "Anti Parietal ab", code: "86162" },
      { name: "C1I", code: "86162" },
      { name: "alpha1 antitripsin", code: "" },
      { name: "אנטיגן Ro נוגדנים - Anti Ro/ SSA", code: "" },
      { name: "אנטיגן La נוגדנים - Anti La/ SSA", code: "" },
      { name: "Bוגדנים כנד סקלרודרמה - Scl70", code: "86235" },
      { name: "אנטיגן לאוקציטי הומני - HLA B27", code: "" },
      { name: "אנטיגן לאוקציט הומני -  HLA DQ2 / HLA DQ8", code: "" },
      { name: "פקטור ראומטואידי -  RF", code: "86431" },
    ],
  },
  {
    name: "סרולוגיה",
    tests: [
      { name: "הפטיטיס B נוגדנים כנגד מעטפת - Anti HBs", code: "86706" },
      { name: "הפטיטיס B אנטיגן מעטפת - HBsAg", code: "87340" },
      { name: "הפטיטיס B סך נוגדנים כנגד גרעין - Anti HBc Total", code: "86704" },
      { name: "הפטיטיס B נוגדנים IgM כנגד גרעין  - Anti HBc IgM", code: "86705" },
      { name: "הפטיטיס B -נוגדנים כנגד אי - Anti Hbe", code: "87350" },
      { name: "הפטיטיס B אנטיגן אי - HBeAg", code: "87350" },
      { name: "הפטיטיס C נוגדנים  - Anti HCV", code: "86703" },
      { name: "הפטיטיס A  נוגדנים - Anti HA IgG", code: "86709" },
      { name: "הפטיטיס A  נוגדנים - Anti HA IgG", code: "86709" },
      { name: "הפטיטיס אי -   Anti IgG HEV", code: "L6707" },
      { name: "הפטיטיס אי -   Anti IgM HEV", code: "L6707" },
      { name: "נוגדנים אפשטיין בר וירוס - EBV IgG", code: "86406" },
      { name: "נוגדנים אפשטיין בר וירוס - EBV IgM", code: "86406" },
      { name: "נוגדנים ציטומגלי וירוס - CMV IgG", code: "86644" },
      { name: "נוגדנים ציטומגלי וירוס - CMV IgG", code: "86644" },
      { name: "סקר לאיידס - HIV Screening Ag/ Ab", code: "87389" },
      { name: "נוגדנים לאבעבועות רוח - Varicella Zoster IgG Antibodies", code: "87449" },
      { name: "נוגדנים לחצבת -", code: "" },
      { name: "בדיקת מנטו", code: "" },
      { name: "קאונטיפירון - QuantiFERON", code: "L4797" },
      { name: "נוגדנים", code: "" },
    ],
  },
  {
    name: "בדיקות צואה",
    tests: [
      { name: "דם סמוי", code: "" },
      { name: "משטח צואה", code: "" },
      { name: "תרבית צואה", code: "87045" },
      { name: "צואה לקלוסטרידיום דפיצלה", code: "" },
      { name: "צואה לפרזיטים", code: "87174" },
      { name: "צואה למזהמים - Biofire GI", code: "L7179" },
      { name: "אלפה 1 אנטיריפסין", code: "" },
    ],
  },
  {
    name: "בדיקות שתן",
    tests: [
      { name: "נחושת  בשתן  -  Copper urine", code: "L7607" },
      { name: "הידרוקסאינדול חומצה אצטית - 5HIAA", code: "83497" },
      { name: "שתן לכללית ולתרבית", code: "87086" },
      { name: "שצן לעמילאז - Urine Amylase", code: "81150" },
    ],
  },
];
